(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('home.adminCampaignOverview', {
                    requireLogin: true,
                    url: 'admin/campaignOverview',
                    templateUrl: 'app/admin/campaignOverview/campaignOverview.html?app_v=deployDate',
                    data: {
                        authorizedRoles: ['Administrator'],
                        navMarker: ['admin', 'campaignOverview']
                    },
                    controller: 'campaignOverviewCtrl',
                    controllerAs: 'vm'
                })
        }]);
})();